<button ion-button
        clear
        color="primary-blue"
        [disabled]="disabled"
        (click)="showOptions($event)">{{buttonText}}</button>
